// The notice frame's own copy, which the server never translates.
import { toLanguageCode } from "../api/language";
import type { NoticeChromeCopy } from "../types";
import { NOTICE_CHROME_EN, TRANSLATIONS } from "./chromeCopy.data";

export { NOTICE_CHROME_EN };

// Takes the display name the notice holds ("Hindi") or a BCP-47 code, and
// falls back to English per key so a missing string never renders empty.
// "mni" and "mni-Mtei" are the same bundle, as are "pa" and "pa-IN": match the
// exact code first, then the primary subtag, so a caller passing a bare or
// region-tagged code is not silently answered in English.
const primaryOf = (tag: string) => tag.split("-")[0].toLowerCase();

const bundleFor = (code: string): NoticeChromeCopy | undefined => {
  if (TRANSLATIONS[code]) {
    return TRANSLATIONS[code];
  }
  // BCP-47 tags are case-insensitive, and a host may hand us "HI-IN".
  const primary = primaryOf(code);
  const key = Object.keys(TRANSLATIONS).find(
    (candidate) => primaryOf(candidate) === primary,
  );
  return key ? TRANSLATIONS[key] : undefined;
};

export const noticeChromeCopy = (language?: string | null): NoticeChromeCopy => {
  const code = toLanguageCode(language);
  if (!code) {
    return NOTICE_CHROME_EN;
  }
  const bundle = bundleFor(code);
  return bundle ? { ...NOTICE_CHROME_EN, ...bundle } : NOTICE_CHROME_EN;
};

/** Fills the `{answer}` slot of the saved-answer cue. */
export const savedAnswerLabel = (copy: NoticeChromeCopy, answer: string): string =>
  copy.savedAnswer.replace("{answer}", answer);

/** The languages this bundle covers, for tests and tooling. */
export const NOTICE_CHROME_LANGUAGES = Object.keys(TRANSLATIONS);
